'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AutoBind = require('../utils/AutoBind');

var _AutoBind2 = _interopRequireDefault(_AutoBind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TransitionCompleteDelegate(responder, status, behavior, navigator, transitionNamespace) {
    this._responder = responder;
    this._status = status;
    this._behavior = behavior;
    this._navigator = navigator;
    this._transitionNamespace = transitionNamespace;
    this._called = false;
    (0, _AutoBind2.default)(this, this);
}

// PUBLIC API
//  weak
TransitionCompleteDelegate.prototype = {
    call: function call() {
        if (this._called) {
            throw new Error('Illegal second call to transition complete. This instance is already prepared for garbage collection!');
        }

        this._called = true;
        this._transitionNamespace.notifyComplete(this._responder, this._status, this._behavior);
        this._responder = null;
        this._navigator = null;
        this._transitionNamespace = null;
    }
};

exports.default = TransitionCompleteDelegate;
//# sourceMappingURL=TransitionCompleteDelegate.js.map